<template>
  <div>
    <div class="input-group pointer">
      <label class="input-group-btn pointer">
        <span class="btn btn-primary pointer">
          Carregar
          <input
            type="file"
            ref="file"
            v-on:change="sendCurriculum()"
            id="curriculum_pdf"
            name="candidates[curriculum_pdf]"
            style="display: none"
            multiple
          />
        </span>
      </label>
      <input
        type="text"
        class="form-control"
        v-model="name"
        readonly
      />
    </div>
    <span class="help-block">
      Utilize arquivos em formato <b>pdf</b> ou <b>doc</b>
    </span>
  </div>
</template>

<script>
import axios from "axios";
export default {
  props: ["id"],
  data() {
    return {
      file: "",
      name: "",
    };
  },
  methods: {
    sendCurriculum() {
      this.file = this.$refs.file.files[0];
      this.name = this.$refs.file.files[0].name;
      let formData = new FormData();
      let type_file = this.name.toLowerCase().split(".");

      if (
        ["pdf", "doc", "docx"].includes(type_file[type_file.length - 1]) ==
        false
      ) {
        this.$toast.error(
          "Formato do arquivo inválido, aceitamos apenas pdf e doc"
        );
        return;
      }
      eventBus.$emit("curriculum_load", true);

      if (this.file.size > 1024 * 1024) {
        alert("Arquivo muito grande (> 1MB)");
        return;
      }
      formData.append("candidates[curriculum_pdf]", this.file);
      if (this.id){
        formData.append("candidate_id", this.id);
        axios
          .put("/recruiters/curriculum", formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then(function (data) {
            if (!data.data.response) {
              alert(
                "Formato de currículo inválido, tente novamente com o formato pdf ou doc"
              );
              eventBus.$emit("validate_curriculum", data.data);
              return;
            }
            eventBus.$emit("validate_curriculum", data.data);
          })
          .catch((error) => {});
        return;
      }
      axios
        .put("/candidates/curriculum", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then(function (data) {
          eventBus.$emit("curriculum_load", false);

          if (!data.data.response) {
            alert(
              "Formato de currículo inválido, tente novamente com o formato pdf ou doc"
            );
            return;
          }
        })
        .catch((error) => {});
    },
  },
};
</script>